import { GridColDef } from "@mui/x-data-grid-pro"
import { FnAxios, FnDialog, I18n, ParseHtml, RouterDOM } from "utilities/utilities";
import { BtnAddOnTableRender, BtnEditOnTableRender, DefaultParamCol } from "../Ticket/components/CreateColumnTable";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { PaginationInterface, initRows } from 'components/DataGrid';
import { I18NextNs } from "enum/enum";
import { useLocation } from "react-router";
import { useForm } from "react-hook-form";
import moment from "moment";
import { renderCellUpdate } from "../Ticket/fnTickit";
import { GetMenuPermissionParamRoute } from "utilities/SystemFunction";

export function useWithdrawTicket(isSwitch,isPermission) {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [nPrmUser, setNPrmUser] = useState(0);
    const [lstOptionMuseum, setLstOptionMuseum] = useState([]);
    const [nUserType, setNUserType] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [messagePopper, setMessagePopper] = useState("")

    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sUpdate",
        sSortDirection: "desc",
    });

    //#region Form
    const formSearch = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    // #endregion

    useEffect(() => {
        GetCheckEmpMuseum();
    }, [])

    useEffect(() => {
        getTable(dataRow);
    }, [])
// }, [isSwitch])

    const GetCheckEmpMuseum = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, (result) => {
            let objResult = result.objResult;
            setNPrmUser(objResult.nPrmUser)
            setNUserType(objResult.nUserTypeID)
            setLstOptionMuseum(objResult.lstMuseum)
            DialogFn.UnBlockUI();
        });
    };

    const getTable = (p: PaginationInterface) => {
        DialogFn.BlockUI();
        setLoadingTable(true);
        let Param = {
            ...p,
            arrRows: [],
            sOrderTicket: formSearch.getValues("sOrderTicket") ?? "",
            sReceiveName: formSearch.getValues("sReceiveName") ?? "",
            nStartDate: formSearch.getValues("nStartDate") ? formSearch.getValues("nStartDate").valueOf() : null,
            nEndDate: formSearch.getValues("nEndDate") ? formSearch.getValues("nEndDate").valueOf() : null,
            arrMuseumId: formSearch.getValues("arrMuseumId") ?? [],
        };
        AxiosFn.Post(`Ticket/GetTableWithdrawBook`, Param, (result) => {
            setLoadingTable(false);
            let objResult = result.objResult;
            setDataRow({
                ...p,
                arrRows: objResult.lstData,
                nDataLength: objResult.nDataLength,
                nPageIndex: objResult.nPageIndex,
            });
        });
        DialogFn.UnBlockUI();
    };

    const onDelete = (arrSelect) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            setLoadingTable(true);
            AxiosFn.Post(`Ticket/OnDeleteTableWithdrawBook`, { lstId: arrSelect }, () => {
                getTable(dataRow)
                DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent));
                DialogFn.UnBlockUI();
            });
        });
    }

    const handleClearSearch = () => {
        Object.keys(formSearch.getValues()).forEach((key => {
            formSearch.setValue(key, null);
            formSearch.clearErrors(key);
        }))
        getTable(dataRow);
    };


    const dataColumnGettingTicket: GridColDef[] = [
        {
            ...DefaultParamCol,
            field: "",
            width: 60,
            headerName: "",
            type: "actions",
            sortable: false,
            hideable: false,
            flex: 0,
            renderHeader: () => {
                if (isPermission) {
                    return (
                        <BtnAddOnTableRender path={"/WithdrawTicketForm"} nPermision={2} />
                    );
                }
            },
            renderCell: (params) => {
                return (
                    <BtnEditOnTableRender
                        path={"/WithdrawTicketForm"}
                        params={params}
                        nPermision={isPermission ? nPrmUser : 1}
                    />
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sDateWithdraw",
            headerName: `${I18n.SetText("Ticket.DateTicketWithdrawal")}`,
            flex: 1,
        },
        {
            ...DefaultParamCol,
            field: "sOrderTicket",
            headerName: `${I18n.SetText("Ticket.OrderWithdrawal")}`,
            flex: 1,

        },
        {
            ...DefaultParamCol,
            field: "sReceiveName",
            headerName: `${I18n.SetText("Ticket.NameWithdrawal")}`,
            flex: 2.5,
            align: "left",
            renderCell: (params) => {
                return (
                    <>
                        {ParseHtml(params.value)}
                    </>
                );
            },
        },
        // nPrmUser !== 0 && nUserType !== 1 && {
        {
            ...DefaultParamCol,
            field: "sMuseum",
            headerName: `${I18n.SetText("Ticket.OrgWithdrawal")}`,
            flex: 3,
            align: "left",
        },
        {
            ...DefaultParamCol,
            field: "sUpdate",
            headerName: `${I18n.SetText("Ticket.DateUpdate")}`,
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {renderCellUpdate(params, handleClickUpdate)}
                    </>
                )
            }
        },
    ];

    const handleClickUpdate = (event, params) => {
        setAnchorEl(event.currentTarget);
        setMessagePopper(params.row.sUpdateName)
    };



    return {
        dataColumnGettingTicket,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        anchorEl,
        setAnchorEl,
        messagePopper,
        formSearch,
        lstOptionMuseum,
        nPrmUser,
        nUserType,
        handleClearSearch
    };
}


export function useWithdrawTicketForm() {

    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const onClearAttachFile = useRef(null);
  const [isPermission, setIsPermission] = useState<boolean>(false);
  const [arrAttachmentList, setArrAttachmentList] = useState([])
    const [objMuseum, setObjMuseum] = useState({
        nMuseumID: 0,
        sMuseumName: "",
    })
    const [lstSeller, setLstSeller] = useState([])
    const [lstMuseum, setLstMuseum] = useState([])
    const [nUserType, setNUserType] = useState(0);
    const [defaultValues, setDefaultValues] = useState({
        nMuseum: null,
        sMuseum: null,
        sOrderBook: null,
        dTicketWithdrawal: null,
        dSold: null,
        arrSeller: null,
        lstTicket: []
    })
    // #endregion

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: defaultValues
    });
    // #endregion

    const gotoBack = () => {
        Router.GoToPage("/SupplyTicket", {
            state: {
                tab: "WithdrawTicket"
            }
        })
    }

    const handleSubmitForm = () => {
        let lstTicket = form.getValues("lstTicket");
        let indexHasValue = lstTicket.findIndex(f => f.isRequire === true)
        if (indexHasValue === -1 && !objParamPath.ParamId) {
            DialogFn.Warning("ต้องมีรายการเบิกตั๋วอย่างน้อย 1 รายการ");
            return;
        }

        let objParam = {
            sIDWithdraw: objParamPath.ParamId,
            sIDMuseum: objMuseum.nMuseumID + "",
            sOrderBook: form.getValues("sOrderBook"),
            nWithdrawDate: form.getValues("dTicketWithdrawal").valueOf(),
            nSold: form.getValues("dSold").valueOf(),
            arrSeller: form.getValues("arrSeller"),
            lstWithdrawTicket: form.getValues("lstTicket"),
            lstFile: arrAttachmentList,

        };
        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`Ticket/OnSubmitWithdrawBook`, objParam, () => {
                DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                    gotoBack();
                });
            });
        });
    }

    const getOptionInitialData = async (nUserTypeID) => {
        DialogFn.BlockUI();

        await AxiosFn.Get(`Ticket/GetFormInitialTicketBook`, null, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            if (!objResult) return;
            setLstMuseum(objResult.lstMuseum)
            setLstSeller(objResult.lstSeller)
            setObjMuseum({
                nMuseumID: objResult.nMuseumID,
                sMuseumName: objResult.sMuseumName,
            })
            form.setValue("sMuseum", objResult.sMuseumName)
            if (nUserTypeID === 1) {
                getTypeTicketMuseum(objResult.nMuseumID, objResult.sMuseumName)
            }
        });

        if (objParamPath.ParamId) {
            DialogFn.BlockUI();
            await AxiosFn.Get(`Ticket/GetFormInfoWithdrawBook`, { sWithdrawID: objParamPath.ParamId }, (result) => {
                DialogFn.UnBlockUI();
                let objResult = result.objResult;
                if (!objResult) return;
                setLstSeller(objResult.lstSellerOption)
                setDefaultValues({
                    nMuseum: parseInt(objResult.objWithdraw.sIDMuseum),
                    sMuseum: objResult.objWithdraw.sMuseum,
                    sOrderBook: objResult.objWithdraw.sOrderBook,
                    dTicketWithdrawal: moment(objResult.objWithdraw.nWithdrawDate),
                    dSold: moment(objResult.objWithdraw.nSold),
                    arrSeller: objResult.objWithdraw.arrSeller,
                    lstTicket: objResult.lstTicket
                })

                setArrAttachmentList(objResult.lstFile)
            });
        }

    };

    const getTypeTicketMuseum = (nMuseumID, sMuseumName = null, dReceive = null) => {
        if (!nMuseumID) {
            setObjMuseum({
                nMuseumID: 0,
                sMuseumName: "",
            })
            setDefaultValues(value => {
                return ({
                    ...value,
                    dTicketWithdrawal: dReceive != null ? moment(dReceive) : null,
                    dSold: dReceive != null ? moment(dReceive) : null,
                    sOrderBook: form.getValues("sOrderBook"),
                    lstTicket: []
                })
            })
            return;
        }

        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetTypeTicketWithdraw`, { nMuseumID: nMuseumID, dReceive: dReceive }, (result) => {
            DialogFn.UnBlockUI();
            setObjMuseum({
                nMuseumID: nMuseumID,
                sMuseumName: sMuseumName,
            })
            let objResult = result.objResult;
            if (!objResult) return;

            setLstSeller(objResult.lstSeller)
            setDefaultValues(value => {
                return ({
                    ...value,
                    nMuseum: nMuseumID,
                    sMuseum: sMuseumName,
                    sOrderBook: form.getValues("sOrderBook"),
                    dTicketWithdrawal: dReceive != null ? moment(dReceive) : null,
                    dSold: dReceive != null ? moment(dReceive) : null,
                    lstTicket: objResult.TypeTicket
                })
            })
        });
    };

    const GetCheckEmpMuseum = async () => {
        DialogFn.BlockUI();
        await AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, async (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setNUserType(objResult.nUserTypeID)
            await getOptionInitialData(objResult.nUserTypeID)
        });
    };


    useEffect(() => {
    GetMenuPermissionParamRoute("/SupplyTicket",AxiosFn, setIsPermission, DialogFn);
    GetCheckEmpMuseum();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        form.reset(defaultValues);
    }, [defaultValues, form])

    return {
        objParamPath,
        onClearAttachFile,
        arrAttachmentList,
        setArrAttachmentList,
        defaultValues,
        form,
        gotoBack,
        handleSubmitForm,
        objMuseum,
        lstMuseum,
        lstSeller,
        nUserType,
        getTypeTicketMuseum,
    isView : !isPermission,

    }

}